export const SIDE_PADDING = 15;
